import { oc } from '@orpc/contract';
import { saveReportInputSchema, saveReportOutputSchema } from '../schemas/reports.schemas.js';
export const saveReportContract = oc
    .route({
    method: 'POST',
    path: '/reports',
    tags: ['Reports'],
    summary: 'Freeze an immutable report snapshot from the current runs and the edited texts',
    description: 'The server rebuilds the entire snapshot from the vehicle ids and the per-test scenario and run ids — a client-supplied payload is never trusted — applies the edited title, takeaway and conclusions, and stores the result. Reports are immutable (plan §3.3, §8): there is no update and no delete, so a rule change later produces a new report rather than editing this one.',
})
    .input(saveReportInputSchema)
    .output(saveReportOutputSchema);
//# sourceMappingURL=save-report.contract.js.map